import { gql, useMutation } from '@apollo/client';
import { GET_PROJECT_PAGES } from '../gql/getProjectPages.graphql';
import { translate } from 'javascripts/translations/i18n';
import toast from 'helpers/toast';
import { useCallback } from 'react';

export const DELETE_PROJECT_PAGE = gql`
  mutation DeleteProjectPage($input: DeleteProjectPageInput!) {
    deleteProjectPage(input: $input) {
      errors {
        error
        message
      }
    }
  }
`;

const useDeleteProjectPage = ({ projectNodeId, onDelete = () => {} }) => {
  const [deleteProjectPageMutation, { loading }] = useMutation(
    DELETE_PROJECT_PAGE,
    {
      onError: () => {
        toast.error(translate('projectPage.hooks.deleteProjectPageError'));
      },
      onCompleted: () => {
        toast.success(translate('projectPage.hooks.deleteProjectPageSuccess'));
        onDelete();
      },
      refetchQueries: [
        {
          query: GET_PROJECT_PAGES,
          variables: { projectNodeId },
        },
        'getProjectPages',
      ],
    },
  );

  const deleteProjectPage = useCallback(
    (pageId) =>
      deleteProjectPageMutation({
        variables: {
          input: {
            pageId,
          },
        },
      }),
    [deleteProjectPageMutation],
  );

  return {
    deleteProjectPage,
    loading,
  };
};

export default useDeleteProjectPage;
